import { createRouter, createWebHistory } from 'vue-router';

// Define routes
const routes = [
    // {
    //     path: '/register',
    //     name: 'register',
    //     component: () => import(/* webpackChunkName: "register" */ "@/views/register/Index"),
    // },
    {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ "@/views/profile/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/profile/bet',
        name: 'bet',
        component: () => import(/* webpackChunkName: "bet" */ "@/views/profile/bet/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ "@/views/home/Index"),
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import(/* webpackChunkName: "login" */ "@/views/login/Index"),
    // },
    {
        path: '/details/headtohead/:id',
        name: 'headtohead',
        component: () => import(/* webpackChunkName: "headtohead" */ "@/views/details/headtohead/Index"),
        props: true,
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament',
        name: 'tournament',
        component: () => import(/* webpackChunkName: "tournament" */ "@/views/details/tournament/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament/pool',
        name: 'pool',
        component: () => import(/* webpackChunkName: "pool" */ "@/views/details/tournament/pool/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament/group',
        name: 'group',
        component: () => import(/* webpackChunkName: "group" */ "@/views/details/tournament/group/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament/kingofhill',
        name: 'kingofhill',
        component: () => import(/* webpackChunkName: "kingofhill" */ "@/views/details/tournament/kingofhill/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament/parlay',
        name: 'parlay',
        component: () => import(/* webpackChunkName: "parlay" */ "@/views/details/tournament/parlay/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament/checkpoint',
        name: 'checkpoint',
        component: () => import(/* webpackChunkName: "checkpoint" */ "@/views/details/tournament/checkpoint/Index"),
        meta: { requiresAuth: true },
    },
    {
        path: '/details/tournament/timeattack',
        name: 'timeattack',
        component: () => import(/* webpackChunkName: "timeattack" */ "@/views/details/tournament/timeattack/Index"),
        meta: { requiresAuth: true },
    },
];

// Create router instance
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

// Global Navigation Guard
router.beforeEach((to, from, next) => {
    const isLoggedIn = !!localStorage.getItem('token'); // Check for token

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // If route requires auth and user is not logged in
        if (!isLoggedIn) {
            next({ name: 'home' }); // Redirect to home
        } else {
            next(); // Proceed
        }
    } else {
        next(); // Proceed if no auth required
    }
});

export default router;